<script setup>
import {ref, onMounted, watch, nextTick} from "vue";

const props = defineProps({
    amount: Number,
    currency: String,
    slug: String,
});

const emit = defineEmits([
    'enroll-course-paypal',
]);

const paypalContainer = ref(null);
const paypalLoaded = ref(false);
const buttonsRendered = ref(false); // Track if buttons have been rendered

const enrollCourse = () => {
   emit('enroll-course-paypal', props.slug);
};

const loadPayPalScript = async () => {
    if (window.paypal) {
        //console.log("PayPal SDK already loaded");
        paypalLoaded.value = true;
        await nextTick();
        renderPayPalButton();
        return;
    }

    //console.log("Loading PayPal SDK...");
    const script = document.createElement("script");
    script.src =
        `https://www.paypal.com/sdk/js?client-id=AQNIamekygg2Zo25-hXIpy0mcyNz1IactAo33-G0kpDbmHKHkb2uQWm1_tXXslUEKX4YEJD7Xavi8mBD&currency=${props.currency || 'USD'}`;
    script.async = true;
    script.onload = async () => {
        //console.log("PayPal SDK Loaded Successfully");
        paypalLoaded.value = true;
        await nextTick();
        renderPayPalButton();
    };
    script.onerror = () => {
        //console.error("Failed to load PayPal SDK");
    };

    document.body.appendChild(script);
};

const renderPayPalButton = () => {
    if (!paypalLoaded.value) {
        //console.warn("PayPal SDK is not fully loaded yet!");
        return;
    }

    if (!paypalContainer.value) {
        //console.error("PayPal container is missing! Retrying...");
        setTimeout(renderPayPalButton, 300); // Retry after 300ms
        return;
    }

    if (buttonsRendered.value) {
        //console.log("PayPal buttons already rendered, skipping duplicate render.");
        return;
    }

    //console.log("Rendering PayPal buttons inside:", paypalContainer.value);

    // Clear previous buttons before rendering new ones
    paypalContainer.value.innerHTML = "";
    let paypalButtonsComponent;
    window.paypal.Buttons({
        style: {
            layout: "vertical",
            color: "gold",
            shape: "rect",
            label: "paypal",
        },
        onInit: function(data, actions) {
            actions.disable();
            paypalButtonsComponent = actions; // Store the actions object
        },
        onClick:(data, actions) => {
            enrollCourse();
        },
        createOrder: (data, actions) => {
            return actions.order.create({
                purchase_units: [{
                    amount: {
                        value: props.amount,
                        currency_code: props.currency || "USD"
                    }
                }]
            });
        },
        onApprove: async (data, actions) => {
            const order = await actions.order.capture();
            //console.log("Order Completed:", order);
            alert("Payment Successful!");
        },
        onError: (err) => {
            //console.error("❌ PayPal Error:", err);
        }
    }).render(paypalContainer.value);

    buttonsRendered.value = true; // Mark as rendered
};

// 🔄 Watch for changes to `paypalLoaded` and re-render if needed
watch(paypalLoaded, (newVal) => {
    if (newVal) {
        renderPayPalButton();
    }
});


onMounted(() => {
    loadPayPalScript();
});
</script>

<template>
    <div>
        <p v-if="!paypalLoaded">Loading PayPal...</p>
        <div v-else ref="paypalContainer"></div>
    </div>
</template>
